import { z } from 'zod'
import { parseTimestamp } from '@/util/zod/validators'

/**
 * A Matter artifact's sticky template choice — one entry per Matter artifact, shared by
 * all of its versions.
 */
export const MatterArtifactTemplateSelectionReadSchema = z.object({
  matter_artifact_id: z.string().uuid(),
  template_user_file_id: z.string().uuid(),
})
export type MatterArtifactTemplateSelectionRead = z.infer<typeof MatterArtifactTemplateSelectionReadSchema>

/**
 * Metadata of the template applied to a specific Matter artifact version. There is no
 * stored output path — delivery is via signed URLs fetched on demand.
 *
 * `template_user_file_id` can be null: if the template is deleted after an export, the formatting
 * still happened and the output persists, so the entry stays (the name just won't resolve).
 *
 * `template_user_file_id` may also reference a soft-deleted file: the backend surfaces the applied
 * row as-is. The freshness rule degrades correctly — the selection read filters soft-deleted files,
 * so the mismatch reads as stale and a re-apply is offered.
 */
export const MatterArtifactAppliedTemplateReadSchema = z.object({
  matter_artifact_version_id: z.string().uuid(),
  template_user_file_id: z.string().uuid().nullable(),
  last_applied_at: z.preprocess((val, ctx) => parseTimestamp(val, ctx), z.number()),
})
export type MatterArtifactAppliedTemplateRead = z.infer<typeof MatterArtifactAppliedTemplateReadSchema>
